import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import EyeSlash from "../../Assets/Image/admin/slasheye.png";
import Eye from "../../Assets/Image/admin/eye.png";
import logo from "../../Assets/Image/admin/logo.png";
import { Circles } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import BigLogo from "../../Assets/Image/sidebar/e-logo.png";
import { v4 as uuidv4 } from "uuid";
import { loginApi } from "../../Services/ApiServices";
import toast from "react-hot-toast";

function Login() {
  const navigate = useNavigate();
  const [eyes, setEyes] = useState(0);
  const [texts, setTexts] = useState("password");
  const [isLoading, setIsLoading] = useState(false);

  let deviceId = localStorage.getItem("DeviceId");

  useEffect(() => {
    if (!deviceId) {
      deviceId = uuidv4();
      localStorage.setItem("DeviceId", deviceId);
    }
  }, [deviceId]);

  const handleEyes = () => {
    const flag = eyes === 0 ? 1 : 0;
    setEyes(flag);

    const text = texts === "password" ? "text" : "password";
    setTexts(text);
  };

  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Please enter valid email address")
      .matches(/^[a-z0-9._%+-]+@gmail\.com$/, "Please enter valid email address")
      .required("Please enter email address"),
    password: Yup.string()
      .required("Please enter password"),
  });

  const handleSubmit = (values) => {
    setIsLoading(true);
    const body = {
      email_id: values?.email,
      password: values?.password,
      device_id: deviceId,
      device_token: "123",
      device_type: "Web",
    };

    loginApi(body)
      .then((res) => {
        toast.success(res?.data?.message || "Login Successfully!");
        localStorage.setItem("token", res?.data?.token);
        navigate("/dashboard");
        setIsLoading(false);
      }).catch((err) => {
        toast.error(err?.response?.data?.message);
        setIsLoading(false);
      });
  };

  return (
    <div className="grid grid-cols-12 gap-x-6 fontNew">
      <div className="lg:col-span-5 h-[100vh] w-full 2xl:flex xl:flex lg:flex hidden bg-primary">
        <div className="w-full flex flex-col justify-center items-center">
          <img src={logo} className="w-56" alt="" />
        </div>
      </div>
      <div className="lg:col-span-7 col-span-12 mx-5">
        <div className="text-start flex justify-center items-center w-full h-[100vh]">
          <div className="sm:w-auto w-full">
            <div className="lg:hidden flex justify-center mb-10">
              <img src={BigLogo} className="w-[180px] h-[35px]" alt="" />
            </div>
            <h4 className="fontNew sm:text-3xl text-xl font-semibold pb-3">
              Glad to see you!
            </h4>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ errors, touched }) => (
                <Form>
                  <div>
                    <div className="flex items-center mt-3">
                      <p className="fontNew text-sm font-medium">
                        Work Email Address
                      </p>
                    </div>
                    <div className="mt-3 mb-6">
                      <div className="sm:w-[380px] w-full flex mt-3 mb-1 items-center">
                        <Field
                          type="email"
                          name="email"
                          autoComplete="off"
                          className={`bg-transparent px-4 rounded-xl border-2 w-full outline-secondary h-[54px] text-base ${errors.email && touched.email ? "border-red-500" : "border-slate-300"
                            }`}
                          placeholder="Email"
                        />
                      </div>
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-red-500 text-sm"
                      />
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center mt-2">
                      <p className="text-sm font-medium">Password</p>
                    </div>
                    <div className="mt-3 mb-6">
                      <div className="flex mt-3 mb-1 items-center">
                        <Field
                          type={texts}
                          name="password"
                          autoComplete="off"
                          className={`bg-transparent ps-4 pe-12 rounded-xl border-2 w-full outline-secondary h-[54px] text-base ${errors.password && touched.password ? "border-red-500" : "border-slate-300"
                            }`}
                          placeholder="Password"
                        />
                        {eyes === 0 ? (
                          <img
                            src={EyeSlash}
                            onClick={handleEyes}
                            className="p-2 w-10 h-10 -ms-12 cursor-pointer"
                            alt=""
                          />
                        ) : (
                          <img
                            src={Eye}
                            onClick={handleEyes}
                            className="p-2 w-10 h-8 -ms-12 cursor-pointer"
                            alt=""
                          />
                        )}
                      </div>
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="text-red-500 text-sm"
                      />
                    </div>
                  </div>
                  <div className="mt-14">
                    <button
                      type="submit"
                      className="fontNew h-[54px] items-center w-full rounded-2xl flex font-base justify-center text-white text-base bg-primary"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <Circles
                          width={23}
                          height={23}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      ) : (
                        "Login"
                      )}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
